import React from 'react';

import { datadogRum } from '@datadog/browser-rum';
import AddressSearch from '@lendi-jam/address-search';
import { tracking } from '@lendi-jam/tracking';
import { CustomerType, EventCategory } from '@lendi/analytics-web';
import { useSession } from '@lendi/lala-react';

import { GenericPropertySearchHeroContent } from '#contentTypes/GenericPropertySearchHero';


interface PrismicGenericPropertySearchHeroProps {
  component: GenericPropertySearchHeroContent;
}

const GenericPrismicPropertySearch: React.FC<PrismicGenericPropertySearchHeroProps> = ({ component }) => {
  const { main_title, subtitle, background_image_mobile, background_image_sharp } = component.primary;

  const session = useSession();

  return (
    <AddressSearch
      title={main_title.text}
      subtitle={subtitle.text}
      background={background_image_sharp?.fluid?.src}
      backgroundSharp={background_image_sharp?.fluid}
      mobileImage={background_image_mobile?.fluid}
      trackSearchButtonClick={(text: string) => {
        tracking.button.primary(EventCategory.PROPERTY_REPORT, {
          text,
          userId: session.identity?.id,
          anonymousId: window?.localStorage.getItem('ajs_anonymous_id') || undefined,
        });
      }}
      trackLinkClick={(text: string) => {
        tracking.event({
          text,
          event_name: 'Link Clicked',
          linkType: 'Link',
          category: EventCategory.PROPERTY_REPORT,
          customerType: CustomerType.CUSTOMER,
          path: window.location.pathname,
          userId: session.identity?.id,
          anonymousId: window?.localStorage.getItem('ajs_anonymous_id') || undefined,
        });
      }}
      onError={(error: unknown) => {
        datadogRum.addError(error);
      }}
    />
  );
};

export default GenericPrismicPropertySearch;
